<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <b-form-text id="nameInput">Nome *</b-form-text>
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <!-- <b-form-text id="groupNameInputHelp">Nome *</b-form-text> -->
            <b-form-input
              v-model="form.NAME"
              placeholder="Informe o nome"
              maxlength="24"
              size="sm"
              :formatter="notEmpty"
              aria-describedby="nameInput nameInputLiveFeedback"
              id="nameInput"
              :state="nameState && notRepeatedName"
            >
            </b-form-input>
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>

            <b-form-text >Modelo *</b-form-text>
            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <searchable-select
              v-model="form.FK_MODEL"
              :options="actuatorsModels"
              text-field="NAME"
              value-field="ID"
              :state="modelState"
              :clearable="false"
              placeholder="Selecione o modelo *"
            />
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>
          <div class="col-xs-12 pl-3 pr-3">
          <div class="group-inputs-title">Localização:</div>
          <b-form-text >Latitude </b-form-text>
            <!-- <b-form-text v-show="form.LATITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="0"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              maxlength="40"
              size="sm"
            >
              <!-- :formatter='notEmpty' -->
            </b-form-input>
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text >Longitude</b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="0"
              size="sm"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              maxlength="40"
            >
              <!-- :formatter='notEmpty' -->
            </b-form-input>
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>
          </div>
          <!-- <h5>Parâmetros</h5> -->

          <div class="col-xs-12 pl-3 pr-3">
            <div class="group-inputs-title">Parâmetros:</div>

            <!-- <b-form-text v-if='!form.TYPE' id='closureTimeInputLiveHelp'>
              Tempo de fechamento (s)
            </b-form-text>
            <b-form-input v-if='!form.TYPE'
                          v-model='form.CLOSURE_TIME'
                          type='number'
                          min='1'
                          aria-describedby='closureTimeInputLiveHelp'
                          state='valid'>
            </b-form-input>
            <b-form-input v-if='form.TYPE'
                          v-model='form.MAX_FLOW' -->
            <b-form-text
              >Vazão máxima (m³/h)</b-form-text
            >
            <!-- <b-form-text v-show="form.MAX_FLOW"
              >Vazão máxima (m³/h)</b-form-text
            > -->
            <b-form-input
              v-model="form.MAX_FLOW"
              placeholder="0"
              :state="maxFlowState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
            <!-- <b-form-input v-if='form.TYPE'
                          v-model='form.MIN_FLOW' -->
            <b-form-text
              >Vazão mínima (m³/h)</b-form-text
            >
            <!-- <b-form-text v-show="form.MIN_FLOW"
              >Vazão mínima (m³/h)</b-form-text
            > -->
            <b-form-input
              v-model="form.MIN_FLOW"
              placeholder="0"
              :state="minFlowState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
            <!-- <b-form-input v-if='form.TYPE'
                          v-model='form.REQ_PRES' -->
            <b-form-text
              >Pressão requerida (bar)</b-form-text
            >
            <!-- <b-form-text v-show="form.REQ_PRES"
              >Pressão requerida (bar)</b-form-text
            > -->
            <b-form-input
              v-model="form.REQ_PRES"
              placeholder="0"
              :state="reqPresState"
              size="sm"
            ></b-form-input>
            <!-- :formatter='notEmpty' -->
          </div>
          <div v-if="isPirModel" class="col-xs-12 pl-3 pr-3">
            <div class="group-inputs-title">Segurança do pivô:</div>
            <b-form-text>Tempo de validação na partida (s, {{ pirLimits.PIR_CHECK_TIME.min }}–{{ pirLimits.PIR_CHECK_TIME.max }})</b-form-text>
            <b-form-input
              v-model.number="form.PIR_CHECK_TIME"
              type="number"
              :min="pirLimits.PIR_CHECK_TIME.min"
              :max="pirLimits.PIR_CHECK_TIME.max"
              size="sm"
              :state="pirCheckTimeState"
            />
            <b-form-text>Tempo de filtro de falha em movimento (s, {{ pirLimits.PIR_FAULT_TIME.min }}–{{ pirLimits.PIR_FAULT_TIME.max }})</b-form-text>
            <b-form-input
              v-model.number="form.PIR_FAULT_TIME"
              type="number"
              :min="pirLimits.PIR_FAULT_TIME.min"
              :max="pirLimits.PIR_FAULT_TIME.max"
              size="sm"
              :state="pirFaultTimeState"
            />
            <b-form-text>Validação e filtro requerem DIR-PIR com firmware D024 ou mais novo.</b-form-text>
            <b-form-text>Pressão mínima para início (bar, 0–{{ pirLimits.PIR_PRESSURE_MIN.max }})</b-form-text>
            <b-form-input
              v-model="form.PIR_PRESSURE_MIN"
              type="number"
              step="0.1"
              :min="0"
              :max="pirLimits.PIR_PRESSURE_MIN.max"
              placeholder="Vazio = mantém o valor atual do DIR"
              size="sm"
              :state="pirPressureState"
            />
          </div>
          <div class="col-xs-12 pl-3 pr-3">
          <div class="group-inputs-title">Hidrômetro</div>
            <!-- <b-form-text v-show="form.FK_HYDRO">Hidrômetro</b-form-text> -->
            <searchable-select
              v-model="form.FK_HYDRO"
              :options="hydros"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Hidrômetro"
            />
            <div class="group-inputs-title">Sensor de pressão</div>
            <searchable-select
              v-model="form.FK_SENSOR_PRESSURE"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <!-- <b-form-select v-model='form.FK_MASTER' -->
            <div class="group-inputs-title">Bomba</div>
            <!-- <b-form-text v-show="form.FK_PUMP">Bomba</b-form-text> -->
            <searchable-select
              v-model="form.FK_PUMP"
              :options="pumps"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Bomba"
            />
            <div class="group-inputs-title">Sensor de feedback</div>
            <searchable-select
              v-model="form.FK_SENSOR"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <b-form-text v-show="form.FK_SENSOR && form.POS_SENSOR"
              >Medição do Sensor</b-form-text
            >
            <b-form-select
              v-if="form.FK_SENSOR"
              v-model="form.POS_SENSOR"
              size="sm"
              :state="sensorMeasureToActuatorState"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <template v-if="form.FK_SENSOR && form.POS_SENSOR !== null">
              <b-form-text>Condição de ativação</b-form-text>
              <b-input-group size="sm">
                <b-form-select
                  v-model="form.ACTION_SENSOR"
                  :state="actionSensorState"
                  style="max-width: 140px"
                >
                  <template slot="first">
                    <option :value="null">Condição</option>
                  </template>
                  <option :value="0">Maior que</option>
                  <option :value="1">Menor que</option>
                </b-form-select>
                <b-form-input
                  v-model="form.VALUE_SENSOR"
                  placeholder="Valor"
                  type="number"
                  :state="valueSensorState"
                />
              </b-input-group>
            </template>
            <template v-if="form.FK_SENSOR">
              <b-form-checkbox
                v-model="form.FEEDBACK_ERR_ENABLED"
                :value="1"
                :unchecked-value="0"
                size="sm"
                class="mt-2"
                switch
              >
                Habilitar intertravamento
              </b-form-checkbox>
              <b-form-text>Tempo máximo de confirmação (s)</b-form-text>
              <b-form-input
                v-model.number="form.FEEDBACK_ERR_TIME"
                type="number"
                min="1"
                size="sm"
                :state="feedbackErrTimeState"
              />
            </template>
            <div class="group-inputs-title">Sensor de bloqueio de segurança</div>
            <searchable-select
              v-model="form.FK_SENSOR_LOCK"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />
            <b-form-text v-show="form.FK_SENSOR_LOCK && form.POS_SENSOR_LOCK"
              >Medição do Sensor</b-form-text
            >
            <b-form-select
              v-if="form.FK_SENSOR_LOCK"
              v-model="form.POS_SENSOR_LOCK"
              size="sm"
              :state="sensorMeasureLockState"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR_LOCK
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <template v-if="form.FK_SENSOR_LOCK && form.POS_SENSOR_LOCK !== null">
              <b-form-text>Faixa permitida para partida e operação</b-form-text>
              <b-input-group size="sm">
                <b-form-input
                  v-model="form.MIN_VALUE_SENSOR_LOCK"
                  placeholder="Mínimo"
                  type="number"
                  :state="lockRangeState"
                />
                <b-form-input
                  v-model="form.MAX_VALUE_SENSOR_LOCK"
                  placeholder="Máximo"
                  type="number"
                  :state="lockRangeState"
                />
              </b-input-group>
            </template>
            <div class="group-inputs-title">Sensor de posição</div>
            <searchable-select
              v-model="form.FK_SENSOR_POS"
              :options="positionSensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              placeholder="Sensor"
            />

          </div>
          <div class="col-xs-12 pl-3 pr-3">
            <div class="group-inputs-title">
              Extra:
            </div>
            <b-form-text>Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              size="sm"
            >
            </b-form-input>
          </div>
        </b-form>
      </div>
      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" @click="$emit('close-form')" class="ml-2 mr-1"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1 mr-2"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";

// Mesmas faixas do backend (sir-prod/src/actuator/pirSafety.js) e do DIR D024;
// padrões iguais aos da flash do DIR (sirv4#465, fw_cir#204 R7).
const PIR_LIMITS = {
  PIR_CHECK_TIME: { min: 1, max: 10, def: 5 },
  PIR_FAULT_TIME: { min: 1, max: 5, def: 3 },
  // Fundo de escala do sensor 4-20 mA do PIR (fw_cir, PIR_PRESSURE_SCALE).
  PIR_PRESSURE_MIN: { min: 0, max: 10 },
};

function inPirRange(value, { min, max }) {
  return Number.isInteger(value) && value >= min && value <= max;
}

export default {
  name: "actuator-form",
  components: {
    SearchableSelect,
  },
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    actuatorsModels: Array,
    hydros: Array,
    pumps: Array,
    sensors: Array,
    auxSensors: Array,
    itemToEdit: [Number, Object],
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        MAX_FLOW: null,
        MIN_FLOW: null,
        REQ_PRES: null,
        FK_HYDRO: null,
        FK_SENSOR_PRESSURE: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        VALUE_SENSOR: null,
        FEEDBACK_ERR_ENABLED: 0,
        FEEDBACK_ERR_TIME: 300,
        FK_SENSOR_LOCK: null,
        POS_SENSOR_LOCK: null,
        MIN_VALUE_SENSOR_LOCK: null,
        MAX_VALUE_SENSOR_LOCK: null,
        FK_SENSOR_POS: null,
        FK_PUMP: null,
        NOTE: null,
        PIR_CHECK_TIME: PIR_LIMITS.PIR_CHECK_TIME.def,
        PIR_FAULT_TIME: PIR_LIMITS.PIR_FAULT_TIME.def,
        PIR_PRESSURE_MIN: null,
      },
      pirLimits: PIR_LIMITS,
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.NAME = this.itemToEdit.NAME;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.FK_HYDRO = this.itemToEdit.FK_HYDRO;
          this.form.FK_SENSOR = this.itemToEdit.FK_SENSOR;
          this.form.POS_SENSOR = this.itemToEdit.POS_SENSOR;
          this.form.ACTION_SENSOR = this.itemToEdit.ACTION_SENSOR;
          this.form.VALUE_SENSOR = this.itemToEdit.VALUE_SENSOR;
          this.form.FEEDBACK_ERR_ENABLED = this.itemToEdit.FEEDBACK_ERR_ENABLED || 0;
          this.form.FEEDBACK_ERR_TIME = this.itemToEdit.FEEDBACK_ERR_TIME || 300;
          this.form.FK_SENSOR_LOCK = this.itemToEdit.FK_SENSOR_LOCK;
          this.form.POS_SENSOR_LOCK = this.itemToEdit.POS_SENSOR_LOCK;
          this.form.MIN_VALUE_SENSOR_LOCK = this.itemToEdit.MIN_VALUE_SENSOR_LOCK;
          this.form.MAX_VALUE_SENSOR_LOCK = this.itemToEdit.MAX_VALUE_SENSOR_LOCK;
          this.form.FK_SENSOR_POS = this.itemToEdit.FK_SENSOR_POS;
          this.form.FK_SENSOR_PRESSURE = this.itemToEdit.FK_SENSOR_PRESSURE;
          this.form.FK_PUMP = this.itemToEdit.FK_PUMP;
          this.form.MAX_FLOW = this.itemToEdit.MAX_FLOW;
          this.form.MIN_FLOW = this.itemToEdit.MIN_FLOW;
          this.form.REQ_PRES = this.itemToEdit.REQ_PRES;
          this.form.NOTE = this.itemToEdit.NOTE;
          this.form.PIR_CHECK_TIME = this.itemToEdit.PIR_CHECK_TIME != null ? this.itemToEdit.PIR_CHECK_TIME : PIR_LIMITS.PIR_CHECK_TIME.def;
          this.form.PIR_FAULT_TIME = this.itemToEdit.PIR_FAULT_TIME != null ? this.itemToEdit.PIR_FAULT_TIME : PIR_LIMITS.PIR_FAULT_TIME.def;
          this.form.PIR_PRESSURE_MIN = this.itemToEdit.PIR_PRESSURE_MIN;
          // this.form.TYPE = this.itemToEdit.TYPE;
        }
      }
    },
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    maxFlowState() {
      let maxFlow = String(Number(this.form.MAX_FLOW));
      if (maxFlow == "NaN" || maxFlow < 0) return false;
      return true;
    },
    minFlowState() {
      let minFlow = String(Number(this.form.MIN_FLOW));
      if (minFlow == "NaN" || minFlow < 0) return false;
      return true;
    },
    reqPresState() {
      let reqPres = String(Number(this.form.REQ_PRES));
      if (reqPres == "NaN" || reqPres < 0) return false;
      return true;
    },
    sensorMeasureToActuatorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR === null) return false;
      return true;
    },
    actionSensorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR !== null && this.form.ACTION_SENSOR === null) return false;
      return true;
    },
    valueSensorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR !== null && (this.form.VALUE_SENSOR === null || this.form.VALUE_SENSOR === "")) return false;
      return true;
    },
    feedbackErrTimeState() {
      if (this.form.FEEDBACK_ERR_ENABLED && (!this.form.FEEDBACK_ERR_TIME || this.form.FEEDBACK_ERR_TIME < 1)) return false;
      return true;
    },
    sensorMeasureLockState() {
      if (this.form.FK_SENSOR_LOCK && this.form.POS_SENSOR_LOCK === null) return false;
      return true;
    },
    lockRangeState() {
      if (this.form.FK_SENSOR_LOCK && this.form.POS_SENSOR_LOCK !== null) {
        if (this.form.MIN_VALUE_SENSOR_LOCK === null || this.form.MIN_VALUE_SENSOR_LOCK === "") return false;
        if (this.form.MAX_VALUE_SENSOR_LOCK === null || this.form.MAX_VALUE_SENSOR_LOCK === "") return false;
        if (Number(this.form.MIN_VALUE_SENSOR_LOCK) >= Number(this.form.MAX_VALUE_SENSOR_LOCK)) return false;
      }
      return true;
    },
    isPirModel() {
      const model = (this.actuatorsModels || []).find((m) => m.ID == this.form.FK_MODEL);
      return !!model && model.NAME === "PIR";
    },
    // Fora do PIR os campos nem aparecem, então não podem travar o salvar.
    pirCheckTimeState() {
      return !this.isPirModel || inPirRange(this.form.PIR_CHECK_TIME, PIR_LIMITS.PIR_CHECK_TIME);
    },
    pirFaultTimeState() {
      return !this.isPirModel || inPirRange(this.form.PIR_FAULT_TIME, PIR_LIMITS.PIR_FAULT_TIME);
    },
    pirPressureState() {
      const v = this.form.PIR_PRESSURE_MIN;
      if (!this.isPirModel || v === null || v === "") return true;
      const n = Number(v);
      return Number.isFinite(n) && n >= PIR_LIMITS.PIR_PRESSURE_MIN.min && n <= PIR_LIMITS.PIR_PRESSURE_MIN.max;
    },
    positionSensors() {
      return this.sensors.filter((s) => s.NAME_MODEL === "SPG");
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME: "",
        FK_MODEL: null,
        LATITUDE: null,
        LONGITUDE: null,
        MAX_FLOW: null,
        MIN_FLOW: null,
        REQ_PRES: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        ACTION_SENSOR: null,
        VALUE_SENSOR: null,
        FEEDBACK_ERR_ENABLED: 0,
        FEEDBACK_ERR_TIME: 300,
        FK_SENSOR_LOCK: null,
        POS_SENSOR_LOCK: null,
        MIN_VALUE_SENSOR_LOCK: null,
        MAX_VALUE_SENSOR_LOCK: null,
        FK_SENSOR_POS: null,
        FK_SENSOR_PRESSURE: null,
        FK_PUMP: null,
        NOTE: null,
        PIR_CHECK_TIME: PIR_LIMITS.PIR_CHECK_TIME.def,
        PIR_FAULT_TIME: PIR_LIMITS.PIR_FAULT_TIME.def,
        PIR_PRESSURE_MIN: null,
      };
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate,
        this.sensorMeasureToActuatorState,
        this.actionSensorState,
        this.valueSensorState,
        this.feedbackErrTimeState,
        this.sensorMeasureLockState,
        this.lockRangeState,
        this.pirCheckTimeState,
        this.pirFaultTimeState,
        this.pirPressureState,
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipmamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus.",
        "Selecione a medição do sensor atribuído ao atuador.",
        "Selecione a condição de ativação (maior que / menor que).",
        "Informe o valor de referência para a condição de ativação.",
        "Informe o tempo máximo de confirmação do feedback (mínimo 1 segundo).",
        "Selecione a medição do sensor de bloqueio de segurança.",
        "Informe uma faixa mínimo/máximo válida para o sensor de bloqueio de segurança (mínimo menor que máximo).",
        `Tempo de validação na partida: inteiro entre ${PIR_LIMITS.PIR_CHECK_TIME.min} e ${PIR_LIMITS.PIR_CHECK_TIME.max} s.`,
        `Tempo de filtro de falha: inteiro entre ${PIR_LIMITS.PIR_FAULT_TIME.min} e ${PIR_LIMITS.PIR_FAULT_TIME.max} s.`,
        `Pressão mínima para início: entre ${PIR_LIMITS.PIR_PRESSURE_MIN.min} e ${PIR_LIMITS.PIR_PRESSURE_MIN.max} bar, ou vazio.`,
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE = !!this.form.LATITUDE
        ? parseFloat(this.form.LATITUDE)
        : null;
      this.form.LONGITUDE = !!this.form.LONGITUDE
        ? parseFloat(this.form.LONGITUDE)
        : null;
      this.form.MAX_FLOW = !!this.form.MAX_FLOW
        ? parseFloat(this.form.MAX_FLOW)
        : null;
      this.form.MIN_FLOW = !!this.form.MIN_FLOW
        ? parseFloat(this.form.MIN_FLOW)
        : null;
      this.form.REQ_PRES = !!this.form.REQ_PRES
        ? parseFloat(this.form.REQ_PRES)
        : null;
      if (this.form.POS_SENSOR == null) {
        this.form.ACTION_SENSOR = null;
        this.form.VALUE_SENSOR = null;
      }
      if (!this.form.FK_SENSOR) {
        this.form.FEEDBACK_ERR_ENABLED = 0;
        this.form.FEEDBACK_ERR_TIME = null;
      }
      if (this.form.POS_SENSOR_LOCK == null) {
        this.form.MIN_VALUE_SENSOR_LOCK = null;
        this.form.MAX_VALUE_SENSOR_LOCK = null;
      } else {
        this.form.MIN_VALUE_SENSOR_LOCK = parseFloat(this.form.MIN_VALUE_SENSOR_LOCK);
        this.form.MAX_VALUE_SENSOR_LOCK = parseFloat(this.form.MAX_VALUE_SENSOR_LOCK);
      }
      // this.form.CLOSURE_TIME = this.form.CLOSURE_TIME > 0 || this.form.CLOSURE_TIME == null ? this.form.CLOSURE_TIME : null;
      if (this.errors.length) this.$refs.formError.show();
      else {
        // Só o PIR usa esses campos; sem eles no payload o backend não mexe na
        // coluna, e um valor esquecido de quando o modelo era PIR não trava o salvar.
        const payload = { ...this.form };
        if (!this.isPirModel) {
          delete payload.PIR_CHECK_TIME;
          delete payload.PIR_FAULT_TIME;
          delete payload.PIR_PRESSURE_MIN;
        } else if (payload.PIR_PRESSURE_MIN === "") {
          payload.PIR_PRESSURE_MIN = null;
        }
        this.$emit("submit", payload);
        this.$emit("close-form");
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0;
    margin-right: 0;
  }
  #form, #details {
    padding-top: 1em;
    /* padding-top: 80px; */
}
}
</style>
